module.exports = __webpack_public_path__ + "media/svg/gs-269d2a73.svg";